import { BaseService, Service } from "/@/cool";
@Service("productSizeRange")
class ProductSizeRange extends BaseService {
	constructor() {
		super();
		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["list"] = prefix + "list";
	}
	list(data: any) {
		return this.request({
			url: "/list",
			method: "POST",
			data
		});
	}
}
export default ProductSizeRange;